"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var YoutubeFilledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,5 C10.7649333,5 12.3108438,5.07300756 13.6377317,5.21902269 L14.071915,5.27040361 C14.9528333,5.38221516 15.6545426,6.06147614 15.7949271,6.93829484 C15.9316424,7.79219656 16,8.64609828 16,9.5 C16,10.1831163 15.9562518,10.8662326 15.8687553,11.5493489 L15.7949476,12.061689 C15.6545624,12.9385188 14.9528446,13.6177887 14.0719154,13.7296017 C12.6516753,13.9098672 10.9610368,14 9,14 C7.23506675,14 5.68915618,13.9269924 4.36226831,13.7809773 L3.92808497,13.7295964 C3.0471667,13.6177848 2.34545735,12.9385239 2.20507292,12.0617052 C2.06835764,11.2078034 2,10.3539017 2,9.5 C2,8.81688368 2.04374824,8.13376737 2.13124472,7.45065105 L2.2050524,6.93831102 C2.34543757,6.06148123 3.04715538,5.38221127 3.92808463,5.27039834 C5.34832474,5.09013278 7.0389632,5 9,5 Z M8,7 L8,12 L11.5,9.5 L8,7 Z" })));
};
YoutubeFilledSmall.displayName = 'YoutubeFilledSmall';
exports.default = YoutubeFilledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=YoutubeFilledSmall.js.map